import * as React from 'react';
import "./patient-timeline.scss"
import { useNavigate } from "react-router-dom";
import Datatable from '../datatable/Datatable';
import axios from 'axios';
import { useState } from 'react';
import PatientFilter from './patientFilter';
import ReuseableButton from '../Buttons/button';
import PersonAddAltIcon from '@mui/icons-material/PersonAddAlt';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import CircularProgress from '@mui/material/CircularProgress';
import PatientCardView from '../PatientCardView/patientCardView';
import { errorToast } from '../toastmessage/toastmessage';

let patientUrl = "https://arogyanxtdevapi.fundaclear.in/api/v1/Patient"

export default function TimelineComponent() {
  const navigate = useNavigate();
  const [patientList, setPatientList] = useState([]);
  const [rowData, setRowData] = useState(null)
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(10)
  const [loading, setLoader] = useState(false);

  const [selectedValue, setSelectedValue] = React.useState('tableView');

  const handleChange = (event) => {
    setSelectedValue(event.target.value);
  };

  const fetchPatient = () => {
    setLoader(true)
    axios.get(patientUrl).then((res) => {
      if (res?.status === 200) {
        setLoader(false)
        setPatientList(res?.data?.result)
      }

    }).catch(err => console.log(err))
  }

  React.useEffect(() => {
    fetchPatient()
  }, [])
  const handleOpdClick = (row) => {
    navigate(`/opd/${row?.uniqueID}`, { state: { rowData: row } })
    setRowData(row)
  }
  const handleIpdClick = (row) => {
    navigate(`/register`, { state: { rowData: row } })
    setRowData(row)
  }

  const handlePatientFilter = (event, value) => {
    event?.preventDefault();
    if (!value?.mobilenumber) {
      errorToast("Enter Valid Mobile Number")
      return;
    } 
      let url = value?.mobilenumber?.length > 0 ? `${patientUrl}?mobilenumber=${value?.mobilenumber}` : null
      axios.get(url).then((res) => {
        if (res?.status === 200) setPatientList(res?.data?.result)

      }).catch((err) => {
        console.log(err)
        errorToast(err?.response?.data?.message)
      })
  }

  const handleClearFilter = async () => {
    await fetchPatient()
  }

  const handlePagination = (newPageSize) => {
    setPage(newPageSize)
    axios.get(`https://arogyanxtdevapi.fundaclear.in/api/v1/Patient?pageNumber=${newPageSize}&pageSize=10`).then((res) => {
      if (res?.status === 200) setPatientList(res?.data?.result)

    }).catch(err => console.log(err))
  }
  const allowNumbersOnly = (e) => {
    let code = (e.which) ? e.which : e.keyCode;
    if (code > 31 && (code < 48 || code > 57)) {
      e.preventDefault();
    }
  }

  const handleRouteBasicInfo = () => {
    navigate("/patient-registration/basic-information", { state: { addPatient: true, rowData: {} } })
  }

  const handleIndividualPatientClick = (e, patientDetails) => {
    e.preventDefault()
    navigate("/patient-registration/patient-id", { state: { patientDetails: patientDetails } })
  }
  const handleOpdCardClick = (e, patientDetails) => {
    e.preventDefault()
    navigate(`/opd/${patientDetails?.uniqueID}`, { state: { rowData: patientDetails } })
    setRowData(patientDetails)
  }

  const handlePathologyClick = (patientInfo) => {
    navigate("/pathalogy", { state: { rowData: patientInfo } })

  }
  return (
    <>
      <div className='d-flex justify-content-end'>
        <div className="view-type mt-3">
          <FormControl>
            <RadioGroup
              row
              aria-labelledby="demo-row-radio-buttons-group-label"
              name="row-radio-buttons-group"
            >

              <FormControlLabel control={<Radio
                checked={selectedValue === 'tableView'}
                onChange={handleChange}
                value="tableView"
                name="radio-buttons"
                inputProps={{ 'aria-label': 'B' }}
              />} label="Table View" />
              <FormControlLabel control={<Radio
                checked={selectedValue === 'cardView'}
                onChange={handleChange}
                value="cardView"
                name="radio-buttons"
                inputProps={{ 'aria-label': 'A' }}
              />} label="Card View" />
            </RadioGroup>
          </FormControl>

        </div>
        <div className="mr-3">
          <ReuseableButton
            text={"Add Patient"}
            height={45}
            colorVarient="success"
            fullWidthFlag={true}
            endIcon={<PersonAddAltIcon />}
            handleChange={handleRouteBasicInfo}
          />
          {/* clicking on basic information */}
        </div>
        <div>
          <PatientFilter
            handleFilterClick={handlePatientFilter}
            onKeyDown={allowNumbersOnly}
            handleClearFilter={handleClearFilter} />
        </div>
      </div>
      <div>
        {selectedValue === "tableView" ?
          <Datatable
            patientList={patientList}
            handleClick={handleOpdClick}
            handleIpdClick={handleIpdClick}
            handlePagination={handlePagination}
            handlePathologyClick={handlePathologyClick}
            path={`/opd/${rowData?.uniqueID}`}
            page={page}
            pageSize={pageSize} />
          :
          loading ? <div style={{ textAlign: "center" }}><CircularProgress disableShrink /></div> :
            <div className="m-4">
              <PatientCardView
                patientList={patientList}
                loading={loading}
                handleIndividualPatientClick={handleIndividualPatientClick}
                handleOpdCardClick={handleOpdCardClick} />
            </div>}
      </div>
    </>
  );
}
